import { cashChangerLog } from '@/apis/aipass'
import serialNumberToHostName from '@/libs/epos-serial-number-to-host'

type ConfigType = {
  hotelId: string
  serialNumber: string
  retry?: number
}
export interface CashChanger {
  initialize: (config: ConfigType) => Promise<{ connection: any; device: any }>
  disconnect: (connection: any, device: any) => void
}

export const useCashChanger = () => {
  const deviceId = 'local_cashchanger'

  const connect = async (serialNumber: string) => {
    const host = await serialNumberToHostName(serialNumber)
    cashChangerLog({ message: 'start', serialNumber: serialNumber, host })
    return await new Promise<any>((resolve, reject) => {
      const ePosDev = new (window as any).epson.ePOSDevice()
      ePosDev.connect(host, 8043, connectStatus => {
        console.log({ connectStatus })
        if (connectStatus !== 'OK' && connectStatus !== 'SSL_CONNECT_OK') {
          reject(`釣銭機に接続できません. status:${connectStatus}`)
          return
        }
        resolve(ePosDev)
      })
      ePosDev.onreconnecting = () => cashChangerLog({ message: 'onreconnecting' })
      ePosDev.onreconnect = () => cashChangerLog({ message: 'onreconnect' })
      ePosDev.ondisconnect = () => cashChangerLog({ message: 'disconnect' })
    })
  }

  const disconnect = (connection, device): void => {
    if (!connection?.isConnected()) {
      return
    }
    if (!device) {
      connection.disconnect()
      return
    }
    connection.deleteDevice(device, () => connection.disconnect())
  }

  const createDevice = async connection => {
    return new Promise<any>((resolve, reject) => {
      connection!.createDevice(
        deviceId,
        connection.DEVICE_TYPE_CASH_CHANGER,
        { crypto: true, buffer: false },
        (deviceObject, errorCode) => {
          if (!deviceObject || errorCode !== 'OK') {
            reject(`釣銭機に接続できません. code:${errorCode}`)
            return
          }
          resolve(deviceObject)
        },
      )
    })
  }

  const initialize = async (config: ConfigType): Promise<{ connection: any; device: any }> => {
    let connectionError

    for (let retry = 0; retry < (config.retry || 1); retry++) {
      try {
        const connection = await connect(config.serialNumber)
        const device = await createDevice(connection)
        return { connection, device }
      } catch (error) {
        connectionError = error
      }
    }
    throw connectionError
  }

  return { initialize, disconnect }
}
